import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { Button, Modal, Popconfirm, Space, Table, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useDelete } from "../../../hooks/apiHooks";
import apiClient from "../../../utils/apiClient";
import useToast from "../../../hooks/userToast";
import DoctorHeader from "../../../doctor/DoctorHeader";
import Sidebar from "../../Sidebar";
import EditTemplate from "./EditTemplate";
import AddTemplateTable from "./AddTemplateTable";
import { plusicon } from "../.././imagepath";
import useUser from "../../../hooks/useUser";

function TemplateTable() {
  const [addModalState, setAddModalState] = useState({ isModalOpen: false });
  const [editModalState, setEditModalState] = useState({
    isModalOpen: false,
    id: null,
    name: "",
    modality: "",
  });
  const [data, setData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const { delLoading } = useDelete();
  const { toastError, toastSuccess } = useToast();
  const { isRadiologist } = useUser();
  const getData = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get(
        `/template?page=${currentPage}&limit=${limit}`,
      );
      setData(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getData();
  }, [currentPage, limit]);
  const refetch = () => {
    setCurrentPage(1);
    setLimit(10);
    getData();
  };

  const showAddModal = () => {
    setAddModalState({ isModalOpen: true });
  };

  const showEditModal = (id, name, modality) => {
    setEditModalState(() => {
      return {
        id,
        name,
        modality,
        isModalOpen: true,
      };
    });
  };

  const handleOk = () => {
    setAddModalState({ isModalOpen: false });
  };

  const handleEditOk = () => {
    setEditModalState(() => {
      return {
        isModalOpen: false,
        id: "",
        name: "",
        modality: "",
      };
    });
  };

  const handleCancel = () => {
    setAddModalState({ isModalOpen: false });
  };

  const handleEditCancel = () => {
    setEditModalState(() => {
      return {
        isModalOpen: false,
        id: "",
        name: "",
        modality: "",
      };
    });
  };

  const handleDelete = (id) => {
    apiClient
      .delete(`template/${id}`)
      .then(() => {
        refetch(); // Refetch the data after successful delete
        toastSuccess("Deleted Successfully!");
      })
      .catch((err) => {
        console.error("Delete failed", err);
        toastError(err?.response?.data?.error);
      });
  };

  const columns = [
    {
      title: "Templates",
      dataIndex: "name",
      key: "name",
      align: "center",
      width: "200",
    },
    {
      title: "Modality",
      dataIndex: "modality",
      key: "modality",
      align: "center",
      render: (text) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            textAlign: "center",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      width: "15%",
      render: (text, record) => (
        <Space style={{ padding: "5px" }}>
          <Tooltip title="Preview">
            <Button
              onClick={() => {
                window.open(record?.template_url, "_blank");
              }}
            >
              <EyeOutlined />
            </Button>
          </Tooltip>
          {!isRadiologist && (
            <Tooltip title="Edit">
              <Button
                onClick={() => {
                  showEditModal(record?.id, record?.name, record?.modality);
                }}
              >
                <EditOutlined />
              </Button>
            </Tooltip>
          )}
          {!isRadiologist && (
            <Tooltip title="Delete">
              <Popconfirm
                title="Are you sure you want to delete?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => handleDelete(record.id)} // Pass the delete function to onConfirm
              >
                <Button>
                  <DeleteOutlined />
                </Button>
              </Popconfirm>
            </Tooltip>
          )}
        </Space>
      ),
      align: "center",
    },
  ];

  if (delLoading) {
    return;
  }
  return (
    <>
      <DoctorHeader />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body cus_box">
                  {/* Table Header */}
                  <div className="page-table-header mb-2">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h2>Templates</h2>
                          <div className="doctor-search-blk">
                            <div className="top-nav-search table-search-blk"></div>
                            {/* <div className="add-group">
                              <Button
                style={{
                  background: "#016FB9",
                  color: "white",
                  fontSize: "14px",
                }}
                type="primary"
                onClick={showAddModal}
              >
                Add
              </Button>
                              </div> */}
                            <div className="add-group">
                              <Tooltip title={` Add Templates`}>
                                <Button
                                  onClick={() => showAddModal()}
                                  className="btn btn-primary add-pluss addone_plus ms-2"
                                >
                                  <img src={plusicon} alt="#" />
                                </Button>
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Table Header */}
                  <div className="table-responsive doctor-list">
                    <Table
                      className="templates_table_border"
                      columns={columns}
                      dataSource={data?.template?.data}
                      rowKey={(record) => record.id}
                      scroll={{ x: 800 }}
                      bordered
                      loading={loading}
                      pagination={{
                        total: data?.template?.total,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        onChange: (page) => {
                          setCurrentPage(page);
                        },
                        showSizeChanger: true,
                        onShowSizeChange: (current, size) => setLimit(size),
                        showQuickJumper: true,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        title="Add Template"
        className="ModalFooterHide"
        open={addModalState.isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        maskClosable={false}
        destroyOnClose
      >
        <AddTemplateTable fetchData={refetch} handleOk={handleOk} type="Add" />
      </Modal>

      <Modal
        className="ModalFooterHide"
        title="Edit Template"
        open={editModalState.isModalOpen}
        onOk={handleEditOk}
        onCancel={handleEditCancel}
        handleOk={handleEditOk}
        maskClosable={false}
        destroyOnClose
      >
        <EditTemplate
          fetchData={refetch}
          id={editModalState.id}
          name={editModalState.name}
          modality={editModalState.modality}
          handleOk={handleEditOk}
        />
      </Modal>
    </>
  );
}

export default TemplateTable;
